/**
 * Google OAuth 2.0 Web client ID (Google Cloud Console → Credentials).
 * Set REACT_APP_GOOGLE_CLIENT_ID in .env.development / .env.production.
 */
export function getGoogleClientId(): string {
  return process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() ?? '';
}

export function isGoogleSignInConfigured(): boolean {
  const id = getGoogleClientId();
  return id.length > 0 && !id.includes('your-client-id');
}
